/* snippet: https://medium.com/@Elijah_Meeks/interactive-applications-with-react-d3-f76f7b3ebc71 */
import React from 'react'
import './styles.scss'
import { Spring, config } from 'react-spring/renderprops.cjs'

function dataLoaded (percentage, total, loadingTime) {
  let percent = total / 100

  if (loadingTime > 36000) {
    return (percentage * percent).toFixed(2)
  } else if (loadingTime > 600) {
    return (percentage * percent).toFixed(1)
  } else {
    return (percentage * percent).toFixed(0)
  }
}

function timeRemaining (percentage, total) {
  let percent = total / 100
  let seconds = Math.ceil(total - percent * percentage)
  return convertSeconds(seconds)
}

function convertSeconds (seconds) {
  let days = Math.floor(seconds / (3600 * 24))
  seconds -= days * 3600 * 24
  let hours = Math.floor(seconds / 3600)
  seconds -= hours * 3600
  let minutes = Math.floor(seconds / 60)
  seconds -= minutes * 60

  let secondsString = seconds === 1 ? ' Sekunde ' : ' Sekunden '
  let minutessString = minutes === 1 ? ' Minute ' : ' Minuten '
  let hoursString = hours === 1 ? ' Stunde ' : ' Stunden '
  let daysString = days === 1 ? ' Tag ' : ' Tage '

  let output = days > 0 ? days + daysString : ''
  output += hours > 0 ? hours + hoursString : ''
  output += minutes > 0 ? minutes + minutessString : ''
  output += seconds + secondsString

  return output

  /* OLDER VERSION
  if (days >= 1) {
    if (hours) {
      return days + daysString + hours + hoursString
    } else {
      return (
        days + daysString + minutes + minutessString
      )
    }
    // return days + daysString + hours + hoursString + minutes + minutessString + seconds + secondsString
  } else if (hours >= 1) {
    if (minutes) {
      return (
        hours + hoursString + minutes + minutessString
      )
    } else {
      return (
        hours + hoursString + seconds + secondsString
      )
    }
    // return hours + hoursString + minutes + minutessString + seconds + secondsString
  } else if (minutes >= 1) {
    return (
      minutes +
      minutessString +
      seconds +
      secondsString
    )
  } else {
    return seconds + ' Sekunden'
  }
  */
}

export class DownloadBar extends React.Component<Props, State> {
  render () {
    let milliseconds = this.props.downloadState === 'running' ? this.props.seconds * 1000 : 0
    return (
      <Spring
        from={{ number: 0 }}
        to={{ number: this.props.downloadState === 'init' ? 0 : 100 }}
        config={{
          duration: milliseconds
        }}
        reset={{ number: this.props.downloadState === 'init' }}
      >
        {props => (
          <div className='loading-container'>
            <div className='year'>{this.props.year}</div>
            <div className='wrapper'>
            <div className='icon-wrapper'>
              <img src={this.props.icon} />
              <div className='rate'>{this.props.downloadrate}</div>
            </div>
            <div className='progress-wrapper'>
              <div className='label-top'>
                {props.number === 100 && (
                  <i className='icon check circle' />
                )}
                {props.number === 0 ? '0 MB geladen'
                  : props.number === 100 ? '' + this.props.mb + ' MB geladen'
                    : '' + dataLoaded(props.number, this.props.mb, this.props.seconds) + ' MB von ' + this.props.mb + ' MB geladen'}
              </div>
              <progress
                max='100'
                value={this.props.downloadState === 'running' ? props.number
                  : this.props.downloadState === 'completed' ? 100 : 0}
                className={props.number === 100 ? 'completed' : 'loading'}
              />{' '}
              <div className='label-bottom'>{this.props.downloadState === 'init' ? '\xa0'
                : props.number === 100 ? 'Ladezeit: ' + convertSeconds(this.props.seconds)
                  : 'Restzeit: ' + timeRemaining(props.number, this.props.seconds)}</div>
            </div>
            </div>
          </div>
        )}
      </Spring>
    )
  }
}
